var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("CabeceraTabla", {
        attrs: { permisoAccion: _vm.accionCrear },
        scopedSlots: _vm._u([
          {
            key: "izquierda",
            fn: function() {
              return [
                _c("BuscadorMantenedor", {
                  attrs: { filter: _vm.funcionFiltrar }
                })
              ]
            },
            proxy: true
          },
          {
            key: "centro",
            fn: function() {
              return [
                _c("ExportarAgGridButton", {
                  attrs: {
                    permisoAccion: _vm.accionExportar,
                    "column-defs": _vm.enrichedGridOptions
                      ? _vm.enrichedGridOptions.columnDefs
                      : _vm.gridOptions.columnDefs,
                    "row-data": _vm.recepciones,
                    "exported-file-name": "RecepcionDeInformacion"
                  }
                })
              ]
            },
            proxy: true
          },
          {
            key: "derecha",
            fn: function() {
              return [
                _c("CrearButton", {
                  attrs: { permisoAccion: _vm.accionCrear },
                  on: {
                    click: function($event) {
                      return _vm.handleCrearClick()
                    }
                  }
                })
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("MantenedorGridTodos", {
        attrs: {
          "grid-options": _vm.gridOptions,
          "funcionalidad-id": _vm.funcionalidad,
          "test-id": "RecepcionesActividad"
        },
        on: {
          gridOptionsEnriched: function($event) {
            _vm.enrichedGridOptions = $event
          }
        }
      }),
      _c("ConfirmacionEliminar", {
        attrs: {
          show: _vm.isConfirmacionEliminarActivo,
          titulo: "Eliminar Recepción de Información",
          mensaje: { entidad: "la Recepción de Información" }
        },
        on: {
          aceptar: _vm.handleConfirmacionEliminar,
          cancelar: _vm.cerrarModalCrud
        }
      }),
      _c("Confirmation", {
        attrs: {
          show: _vm.mostrarInactivoEliminar,
          titulo: _vm.tituloInactivoEliminar,
          mensaje: _vm.mensajeInactivoEliminar,
          mostrarBoton: false,
          textoBtnSi: "Aceptar"
        },
        on: { modalConfirmationEmit: _vm.handleCierreEliminar }
      }),
      _vm.isModalCrearActivo
        ? _c("CrearRecepcionActividadModal", {
            on: { cerrar: _vm.cerrarModalCrud, crear: _vm.handleCrearOrEditar }
          })
        : _vm._e(),
      _vm.isModalEditarActivo
        ? _c("EditarRecepcionActividadModal", {
            attrs: { recepcionActividad: _vm.recepcionSeleccionada },
            on: { cerrar: _vm.cerrarModalCrud, editar: _vm.handleCrearOrEditar }
          })
        : _vm._e(),
      _vm.isModalVerDetalleActivo
        ? _c("VerDetalleRecepcionActividadModal", {
            attrs: { "recepcion-actividad": _vm.recepcionSeleccionada },
            on: { cerrar: _vm.cerrarModalCrud }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }